import React from 'react';
import { useLocation } from 'react-router';
import { DEFAULT_RESET_PASSWORD_DATA, ResetPasswordData, ResetPasswordDataContext } from './context';

const ResetPasswordDataProvider: React.FC<React.PropsWithChildren<Record<never, unknown>>> = ({
  children,
}) => {
  const location = useLocation();
  const [resetPasswordData, setResetPasswordData] =
    React.useState<ResetPasswordData>(DEFAULT_RESET_PASSWORD_DATA);

  React.useEffect(() => {
    setResetPasswordData((current) => ({
      ...current,
      error: null,
      username: null,
      password: null,
      confirmPassword: null,
    }));
  }, [location]);

  return (
    <ResetPasswordDataContext.Provider value={{ resetPasswordData, setResetPasswordData }}>
      {children}
    </ResetPasswordDataContext.Provider>
  );
};

export default ResetPasswordDataProvider;
